// src/App.js
import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import SkillsSection from './components/SkillsSection';
import AboutSection from './components/AboutSection';
import WorksSection from './components/WorksSection';
import BeforeAfterSection from './components/BeforeAfterSection';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import { ToastProvider } from './context/ToastContext';
import ToastContainer from './components/ToastContainer';

function App() {
  return (
    <ToastProvider>
      <div className="App">
        <Navbar />
        <HeroSection />
        <SkillsSection />
        <AboutSection />
        <WorksSection />
        <BeforeAfterSection />
        <ContactForm />
        <Footer />
      </div>
      <ToastContainer />
    </ToastProvider>
  );
}

export default App;
